module.exports = __webpack_public_path__ + "static/media/city-ledger.ae34c9d4.svg";